<template>
  <el-col class="chart-module" :lg="12" v-loading="loading">
    <div class="sub-view">
      <el-row>
        <span style="font-weight: bold">{{ displayTitle }}</span>
        <i
          class="el-icon-close"
          v-if="$root.editMode"
          @click="$root.onClose(title)"
        ></i>
        <i class="el-icon-zoom-in" v-else @click="showPopUp()"></i>
      </el-row>
      <el-row>
        <el-select
          v-model="period"
          @change="periodChange('main')"
          style="width: 30%; padding: 0; float: right"
        >
          <el-option
            v-for="item in periodOpthions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-row>
      <hr />
      <el-row>
        <echarts
          :autoresize="true"
          class="chart-view"
          :option="option"
          @click="onClick"
          @timelinechanged="timelinechanged"
        />
      </el-row>
      <el-dialog
        :visible.sync="popUpDisplay"
        :append-to-body="true"
        class="historyDailog"
      >
        <template slot="title">
          <el-row>
            <span style="font-weight: bold">{{ displayTitle }}</span>
          </el-row>
          <el-row>
            <el-select
              v-model="period"
              @change="periodChange('popup')"
              style="width: 30%; padding: 0; float: right"
            >
              <el-option
                v-for="item in periodOpthions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-row>
        </template>
        <hr />
        <echarts
          :autoresize="true"
          :option="option"
          style="height: 75vh"
          v-loading="popupLoading"
          @click="onClick"
          @timelinechanged="timelinechanged"
        />
      </el-dialog>
    </div>
  </el-col>
</template>
 
<script>
import api from "@/api";
var moment = require("moment-timezone");
export default {
  name: "ChatbotOperateCountChart",
  props: ["title", "displayTitle"],
  data() {
    return {
      periodOpthions: [
        {
          value: "①過去3ヶ月間の同月比",
          label: "①過去3ヶ月間の同月比",
        },
        {
          value: "②過去12ヶ月間の同月比",
          label: "②過去12ヶ月間の同月比",
        },
        {
          value: "③過去3年間の同月比",
          label: "③過去3年間の同月比",
        },
        {
          value: "④過去3年間の同年比",
          label: "④過去3年間の同年比",
        },
      ],
      period: "②過去12ヶ月間の同月比",
      endDate: this.$root.endDate,
      option: this.option,
      loading: this.loading,
      popupLoading: this.popupLoading,
      popUpDisplay: false,
      paramTitle: "全体",
    };
  },
  created() {
    let self = this;
    self.loading = true;
    api.getChatbotOperateCount(this.period, this.endDate, self.$root.facetForEchart,self.$root.ageForEchart,self.$root.sexForEchart).then(
      (res) => {
        let data = res.data;
        let data_list = [];
        let time_line = data.facets;
        for (let i in data.output_list) {
          let obj = {
            title: {
              text: i,
            },
            xAxis: [
              {
                data: data.month_list,
              },
            ],
            series: data.output_list[i],
          };
          data_list.push(obj);
        }
        self.option = {
          baseOption: {
            title: {
              right: "10%",
            },
            timeline: {
              axisType: "category",
              autoPlay: false,
              playInterval: 1000,
              data: time_line,
              label: {
                show: false,
                interval: 0,
                formatter: function (s) {
                  return s;
                },
              },
              padding: [10, -100],
            },
            tooltip: {},
            calculable: true,
            barMaxWidth: "50%",
            grid: {
              top: 80,
              bottom: 80,
            },
            xAxis: [
              {
                type: "category",
                data: data.month_list,
                splitLine: {
                  show: false,
                },
              },
            ],

            yAxis: [
              {
                type: "value",
                name: "件",
              },
            ],
            series: [
              {
                name: "件",
                type: "bar",
              },
            ],
          },
          options: data_list,
        };
        self.loading = false;

      },
      (err) => {
        console.log(err);
      }
    );
  },
  mounted() {
    this.$bus.$on("changeEndMonth", (startDate, endDate) => {
      this.endDate = endDate;
      this.periodChange("main");
    });
  },
  methods: {
    showPopUp() {
      this.popUpDisplay = true;
    },
    timelinechanged(params) {
      this.paramTitle = this.option.options[params.currentIndex].title.text;
    },
    onClick(params) {
      let startDate = "";
      let endDate = "";
      if (params.name.length > 8) {
        startDate = moment(
          params.name.split("~")[0].replace("年", "-").replace("月", "")
        )
          .startOf("month")
          .format("YYYY-MM-DD");
        endDate = moment(
          params.name.split("~")[1].replace("年", "-").replace("月", "")
        )
          .endOf("month")
          .format("YYYY-MM-DD");
      } else if (params.name.length < 8) {
        let baseEndDate = this.endDate.substring(5, 7);
        if (Number(params.name.replace("月", "")) <= Number(baseEndDate)) {
          startDate = moment(
            this.endDate.substring(0, 4) + "-" + params.name.replace("月", "")
          )
            .startOf("month")
            .format("YYYY-MM-DD");
          endDate = moment(
            this.endDate.substring(0, 4) + "-" + params.name.replace("月", "")
          )
            .endOf("month")
            .format("YYYY-MM-DD");
        } else {
          let baseYear = Number(this.endDate.substring(0, 4)) - 1;
          startDate = moment(baseYear + "-" + params.name.replace("月", ""))
            .startOf("month")
            .format("YYYY-MM-DD");
          endDate = moment(baseYear + "-" + params.name.replace("月", ""))
            .endOf("month")
            .format("YYYY-MM-DD");
        }
      } else {
        startDate = moment(params.name.replace("年", "-").replace("月", ""))
          .startOf("month")
          .format("YYYY-MM-DD");
        endDate = moment(params.name.replace("年", "-").replace("月", ""))
          .endOf("month")
          .format("YYYY-MM-DD");
      }

      let ageAndSexStr = '';
      if (this.$root.ageForEchart != '') {
        ageAndSexStr += "&f%5B%5D=cf_89&op%5Bcf_89%5D=~&v%5Bcf_89%5D%5B%5D=" + this.$root.ageForEchart[0];
      }
      if (this.$root.sexForEchart != '') {
        ageAndSexStr += "&f%5B%5D=cf_90&op%5Bcf_90%5D=~&v%5Bcf_90%5D%5B%5D=" + this.$root.sexForEchart[0];
      }
      if (this.paramTitle == "全体") {
        if (params.seriesName == "AI ASSISTANT") {
          window.open(
            this.$root.redmineUrl +
              "/projects/aicc-redmine/issues?utf8=%E2%9C%93&set_filter=1&sort=id%3Adesc&f%5B%5D=status_id&op%5Bstatus_id%5D=c&f%5B%5D=created_on&op%5Bcreated_on%5D=%3E%3C&v%5Bcreated_on%5D%5B%5D=" +
              startDate +
              "&v%5Bcreated_on%5D%5B%5D=" +
              endDate +
              "&f%5B%5D=tracker_id&op%5Btracker_id%5D=%3D&v%5Btracker_id%5D%5B%5D=1&f%5B%5D=&c%5B%5D=tracker&c%5B%5D=cf_45&c%5B%5D=cf_3&c%5B%5D=category&c%5B%5D=cf_22&c%5B%5D=subject&c%5B%5D=cf_37&c%5B%5D=cf_80&c%5B%5D=assigned_to&c%5B%5D=created_on&c%5B%5D=status&c%5B%5D=cf_43&group_by=&t%5B%5D="
              + ageAndSexStr
          );
        } else if (params.seriesName == "AI CHATBOT") {
          window.open(
            this.$root.redmineUrl +
              "/projects/aicc-redmine/issues?utf8=%E2%9C%93&set_filter=1&sort=id%3Adesc&f%5B%5D=status_id&op%5Bstatus_id%5D=c&f%5B%5D=created_on&op%5Bcreated_on%5D=%3E%3C&v%5Bcreated_on%5D%5B%5D=" +
              startDate +
              "&v%5Bcreated_on%5D%5B%5D=" +
              endDate +
              "&f%5B%5D=tracker_id&op%5Btracker_id%5D=%3D&v%5Btracker_id%5D%5B%5D=2&f%5B%5D=&c%5B%5D=tracker&c%5B%5D=cf_45&c%5B%5D=cf_3&c%5B%5D=category&c%5B%5D=cf_22&c%5B%5D=subject&c%5B%5D=cf_37&c%5B%5D=cf_80&c%5B%5D=assigned_to&c%5B%5D=created_on&c%5B%5D=status&c%5B%5D=cf_43&group_by=&t%5B%5D="
              + ageAndSexStr
          );
        }
      } else {
        if (params.seriesName == "AI ASSISTANT") {
          window.open(
            this.$root.redmineUrl +
              "/projects/aicc-redmine/issues?utf8=%E2%9C%93&set_filter=1&sort=id%3Adesc&f%5B%5D=status_id&op%5Bstatus_id%5D=c&f%5B%5D=created_on&op%5Bcreated_on%5D=%3E%3C&v%5Bcreated_on%5D%5B%5D=" +
              startDate +
              "&v%5Bcreated_on%5D%5B%5D=" +
              endDate +
              "&f%5B%5D=cf_22&op%5Bcf_22%5D=%7E&v%5Bcf_22%5D%5B%5D=" +
              this.paramTitle +
              "&f%5B%5D=tracker_id&op%5Btracker_id%5D=%3D&v%5Btracker_id%5D%5B%5D=1&f%5B%5D=&c%5B%5D=tracker&c%5B%5D=cf_45&c%5B%5D=cf_3&c%5B%5D=category&c%5B%5D=cf_22&c%5B%5D=subject&c%5B%5D=cf_37&c%5B%5D=cf_80&c%5B%5D=assigned_to&c%5B%5D=created_on&c%5B%5D=status&c%5B%5D=cf_43&group_by=&t%5B%5D="
              + ageAndSexStr
          );
        } else if (params.seriesName == "AI CHATBOT") {
          window.open(
            this.$root.redmineUrl +
              "/projects/aicc-redmine/issues?utf8=%E2%9C%93&set_filter=1&sort=id%3Adesc&f%5B%5D=status_id&op%5Bstatus_id%5D=c&f%5B%5D=created_on&op%5Bcreated_on%5D=%3E%3C&v%5Bcreated_on%5D%5B%5D=" +
              startDate +
              "&v%5Bcreated_on%5D%5B%5D=" +
              endDate +
              "&f%5B%5D=cf_22&op%5Bcf_22%5D=%7E&v%5Bcf_22%5D%5B%5D=" +
              this.paramTitle +
              "&f%5B%5D=tracker_id&op%5Btracker_id%5D=%3D&v%5Btracker_id%5D%5B%5D=2&f%5B%5D=&c%5B%5D=tracker&c%5B%5D=cf_45&c%5B%5D=cf_3&c%5B%5D=category&c%5B%5D=cf_22&c%5B%5D=subject&c%5B%5D=cf_37&c%5B%5D=cf_80&c%5B%5D=assigned_to&c%5B%5D=created_on&c%5B%5D=status&c%5B%5D=cf_43&group_by=&t%5B%5D="
              + ageAndSexStr
          );
        }
      }
    },
    periodChange(value) {
      let self = this;
      if (value == "main") {
        self.loading = true;
      } else {
        self.popupLoading = true;
      }

      api.getChatbotOperateCount(this.period, this.endDate, self.$root.facetForEchart,self.$root.ageForEchart,self.$root.sexForEchart).then(
        (res) => {
          let data = res.data;
          let data_list = [];
          let time_line = data.facets;
          for (let i in data.output_list) {
            let obj = {
              title: {
                text: i,
              },
              xAxis: [
                {
                  data: data.month_list,
                },
              ],
              series: data.output_list[i],
            };
            data_list.push(obj);
          }
          self.option = {
            baseOption: {
              title: {
                right: "10%",
              },
              timeline: {
                axisType: "category",
                autoPlay: false,
                playInterval: 1000,
                data: time_line,
                label: {
                  show: false,
                  interval: 0,
                  formatter: function (s) {
                    return s;
                  },
                },
                padding: [10, -100],
              },
              tooltip: {},
              calculable: true,
              barMaxWidth: "50%",
              grid: {
                left: '5%',
                right: '5%',
                bottom: '10%',
                top: 80,
                containLabel: true
              },
              xAxis: [
                {
                  type: "category",
                  data: data.month_list,
                  splitLine: {
                    show: false,
                  },
                },
              ],

              yAxis: [
                {
                  type: "value",
                  name: "件",
                },
              ],
              series: [
                {
                  name: "件",
                  type: "bar",
                },
              ],
              // series: [{
              //     name: 'AIアシスタント',
              //     type: 'bar',
              //     stack: '件数',
              //     color: '#61a0a8',
              //     data: [30, 25, 50, 30, 20, 35, 20, 40, 65, 30, 20, 35]
              // }, {
              //     name: 'AIチャットボット',
              //     type: 'bar',
              //     stack: '件数',
              //     color: '#d48265',
              //     data: [40, 30, 60, 20, 30, 40, 25, 30, 70, 20, 25, 40]
              // }]
            },
            options: data_list,
          };
          self.paramTitle = "全体";
          if (value == "main") {
            self.loading = false;
          } else {
            self.popupLoading = false;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
  },
};
</script>
<style>
</style>
